import { useEffect, useRef } from 'react';

const DEFAULT_EVENTS = ['mousedown', 'touchstart'] as const;

// TODO: Move to @quick/utils. This one duplicates `components/src/utils/hooks/useClickOutside`
export function useClickOutside<T extends HTMLElement = HTMLElement>(
  handler: () => void,
  events?: Array<keyof DocumentEventMap> | null,
  nodes?: HTMLElement[]
) {
  const ref = useRef<T>(null);

  useEffect(() => {
    const listener: EventListener = (event) => {
      if (Array.isArray(nodes)) {
        const shouldIgnore = (event?.target as HTMLElement)?.hasAttribute(
          'data-ignore-outside-clicks'
        );
        const shouldTrigger = nodes.every(
          (node) => !!node && !node.contains(event.target as HTMLElement)
        );
        shouldTrigger && !shouldIgnore && handler();
      } else if (
        ref.current &&
        !ref.current.contains(event.target as HTMLElement)
      ) {
        handler();
      }
    };

    (events || DEFAULT_EVENTS).forEach((fn) =>
      document.addEventListener(fn, listener)
    );

    return () => {
      (events || DEFAULT_EVENTS).forEach((fn) =>
        document.removeEventListener(fn, listener)
      );
    };
  }, [ref, handler, nodes, events]);

  return ref;
}
